import useCollection from '../competition-info/submission/hooks/useCollection'

const initialData = {
  completeProposals: {},
  descriptionPdfUrls: {},
  boardsData: {}
}

export default function useSubmittedProposals() {
  const { documents } = useCollection('sub-c-proposals')

  if (!documents) {
    return initialData
  }

  const completeProposals = Object.values(documents).filter(
    doc => doc.proposalStatus === 'valmis'
  )

  const descriptionPdfUrls = Object.fromEntries(
    completeProposals.map(doc => [
      doc.id,
      doc['aaca47a6-7e29-40e2-915a-52bbc9e31d91'].downloadUrl
    ])
  )

  const boardsData = completeProposals.map(doc => ({
    id: doc.id,
    pseudonym: doc.pseudonym,
    board: doc.board
  }))

  const excelData = completeProposals.map(doc => ({
    id: doc.id,
    pseudonym: doc.pseudonym,
    excel: doc['82dcf484-26d4-41fb-b80b-d143c790c155']
  }))

  const modalData = completeProposals.map(doc => ({
    id: doc.id,
    pseudonym: doc.pseudonym,
    modal: doc['c2fe7c34-6500-4681-9f1c-b3efa63d8387']
  }))

  const imagesData = completeProposals.map(doc => ({
    id: doc.id,
    pseudonym: doc.pseudonym,
    aerialView: doc['2dd54880-8404-432e-a80f-a78e54054962'],
    view1: doc['874d730d-d9e0-4282-add8-ec1f62cb054e'],
    view2: doc['ba84f1b9-d833-49b2-9b1f-aa5c6c1215be']
  }))

  const authorData = completeProposals.map(doc => ({
    id: doc.id,
    pseudonym: doc.pseudonym,
    author: doc['1bdde5b0-9d7b-495f-aa4d-65a33780b206']
  }))

  return {
    completeProposals,
    descriptionPdfUrls,
    boardsData,
    excelData,
    modalData,
    imagesData,
    authorData
  }
}
